import { IconNames } from "@shared/enums/icons.enums";
import S from "./AddressSearch.module.scss"
import { Icon } from "@shared/components/Molecules/Icon/Icon.component";
import { useTranslations } from "@shared/context/useTranslations";
import React, { useState, KeyboardEvent, useEffect } from "react";
import { cn } from "@shared/helpers/classNames.helper";

interface AddressSearchProps {
    onUpdate: (query: string) => void;
}
export const AddressSearch = ({ onUpdate }: AddressSearchProps) => {
    const { getTranslation } = useTranslations();
    const [inputValue, setInputValue] = useState("");

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            goToSearch()
        }
    };   
 
    const handleClearInput = () => {
        setInputValue("");
    };

    const goToSearch = () => {
        onUpdate(inputValue);
    };

    useEffect(() => {
        onUpdate(inputValue);
    }, [inputValue, onUpdate]);

    return (
        <div className={S.addressSearchWrapper}>
            <input
                type="text"
                className={S.searchInput}
                placeholder={getTranslation("deliveryAddress.search-bar.placeholder")}
                value={inputValue}
                tabIndex={2}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
            />
            {inputValue === "" ? (
                <div className={cn(S.icon, S.searchIcon)}>
                    <button tabIndex={3} onClick={goToSearch}>
                        <Icon iconName={IconNames.Search} />
                    </button>
                </div>
            ) : (
                <div className={cn(S.icon, S.closeIcon)}>
                    <button onClick={handleClearInput}>
                        <span className={S.clearText}>{getTranslation("header.search-bar.clear-search")}</span>
                        <Icon iconName={IconNames.Close} />
                    </button>
                </div>
            )}            
        </div>
    );
}
